<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
          <span v-if="showBadge(item.children[0].name)" class="menu-badge">{{ badgeCount(item.children[0].name) }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
          <span v-if="showSubmenuBadge(item)" class="menu-badge">{{ submenuBadgeCount(item) }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>
          <!--支持外链功能-->
          <a v-else-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
              <span v-if="showBadge(child.name)" class="menu-badge">{{ badgeCount(child.name) }}</span>
            </el-menu-item>
          </a>
          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
              <span v-if="showBadge(child.name)" class="menu-badge">{{ badgeCount(child.name) }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// 菜单路由 name 与待处理徽标数字段的对应关系
const BADGE_MAP = {
  order: 'wait_send_count',
  recharge: 'wait_freight_audit_count',
  walletRecharge: 'wait_recharge_audit_count',
  repairOrder: 'wait_replenish_audit_count',
  returnApply: 'wait_return_audit_count'
}

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['pendingTotal', 'sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    badgeCount(name) {
      const key = BADGE_MAP[name]
      if (!key) return 0
      return Number(this.pendingTotal[key]) || 0
    },
    showBadge(name) {
      return !this.isCollapse && this.badgeCount(name) > 0
    },
    submenuBadgeCount(item) {
      return (item.children || []).reduce((sum, child) => sum + this.badgeCount(child.name), 0)
    },
    showSubmenuBadge(item) {
      return !this.isCollapse && this.submenuBadgeCount(item) > 0
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu-item,
.el-submenu {
  position: relative;
}

.menu-badge {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue